import { ReactNode, useCallback } from 'react'

import { cn } from '../utils'

interface Props {
  type: 'tip'
  children: ReactNode
  className?: string
}

export function Notice(props: Props) {
  const renderLabel = useCallback((type: string) => {
    switch (type) {
      case 'tip':
        return (
          <div className="text-amber-flame flex items-center gap-1 font-semibold">
            <span className="bg-amber-flame inline-block size-2 rounded-full" />
            <span>Tip</span>
          </div>
        )
      default:
        return null
    }
  }, [])

  return (
    <div className={cn('flex items-start gap-3', props.className)}>
      {renderLabel(props.type)}
      <div className="text-foreground/60">{props.children}</div>
    </div>
  )
}
